import { IItem } from "./IItem";

export interface IExpandable extends IItem {
  expandToBottom(value: number): void;
}

export function instanceOfIExpandable(instance: any): instance is IExpandable {
  return instance
    && (instance.expandToBottom !== undefined);
}
